import React, { useEffect, useState } from "react";

const formatTime = (value) => value.toString().padStart(2, "0");

const SyncedCountdown = ({ startedAt, duration, paused, onComplete }) => {
  const [remaining, setRemaining] = useState(duration * 60);

  useEffect(() => {
    if (!startedAt || paused) return;

    // Calculate initial remaining time based on server timestamp
    const calculateRemaining = () => {
      const now = Date.now();
      const elapsed = (now - startedAt) / 1000; // seconds
      const totalSeconds = duration * 60;
      const remainingSeconds = Math.max(0, totalSeconds - elapsed);
      return Math.floor(remainingSeconds);
    };

    // Set initial value
    setRemaining(calculateRemaining());

    // Update every second
    const interval = setInterval(() => {
      const remainingSeconds = calculateRemaining();
      setRemaining(remainingSeconds);

      if (remainingSeconds <= 0) {
        clearInterval(interval);
        if (onComplete) {
          onComplete();
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [startedAt, duration, paused, onComplete]);

  useEffect(() => {
    if (paused) return;
    const minutes = Math.floor(remaining / 60);
    const seconds = remaining % 60;
    document.title = `Kaizen Flow Room (${formatTime(minutes)}:${formatTime(
      seconds
    )})`;
  }, [remaining, paused]);

  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;

  return (
    <div className="flex flex-col items-center justify-center text-center">
      <p className="mb-3 text-xs uppercase tracking-[0.3em] text-white/70">
        deep work timer
      </p>
      <div className="font-[gilroyextrabold] text-7xl font-black drop-shadow-lg sm:text-8xl">
        {formatTime(minutes)}:{formatTime(seconds)}
      </div>
    </div>
  );
};

export default SyncedCountdown;

